export default __webpack_public_path__ + "static/media/SN4-1.f32c202d.jpg";